import React, { useCallback } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { ProductBacklogRow, isProductBacklogItemRow } from '../productBacklog'
import '../../../../styles/agGrid.scss'

interface ProductBacklogRowNumberCellRendererProps
  extends ICellRendererParams<ProductBacklogRow> {
  projectCode?: string
}

export const ProductBacklogRowNumberCellRenderer: React.FC<
  ProductBacklogRowNumberCellRendererProps
> = props => {
  const { data, value, projectCode } = props

  const projectPlanUuid =
    data && isProductBacklogItemRow(data)
      ? data.cumulation?.projectPlanUuid
      : undefined
  const isLink = projectPlanUuid && projectCode

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      const url = `${window.location.origin}/projectPlan/${projectCode}?treeRootUuid=${projectPlanUuid}`
      window.open(url, '_blank')
    },
    [projectCode, projectPlanUuid]
  )

  return (
    <div className="sevend-ag-cell-sequence-no">
      {isLink ? (
        <a className="sevend-ag-cell-sequence-no__link" onClick={handleClick}>
          {value}
        </a>
      ) : (
        <p className="sevend-ag-cell-sequence-no__label">{value}</p>
      )}
    </div>
  )
}
